import React from 'react';
import FilterPanel from '@spark/ui-components/components/FilterPanel';

const DisponibilidadeFrotaFilter = ({ loading, onApply, onLimpar, title, filters, values, collapseOnSearch = false }) => {
  return (
    <FilterPanel
      filters={filters}
      values={values}
      onApply={onApply}
      onLimpar={onLimpar}
      title={title}
      loading={loading}
      defaultCollapsed={true}
      collapseOnSearch={collapseOnSearch}
    />
  );
};

export default DisponibilidadeFrotaFilter;
